import api from './api';

// Converter base64 para Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Registrar Service Worker
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.log('[Push] Service Worker não suportado');
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    console.log('[Push] Service Worker registrado');
    return registration;
  } catch (error) {
    console.error('[Push] Erro ao registrar SW:', error);
    return null;
  }
}

// Verificar se notificações são suportadas
export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

// Verificar permissão atual
export function getPermissionStatus() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

// Pedir permissão e inscrever
export async function subscribeToPush(userId) {
  if (!isPushSupported()) {
    throw new Error('Push notifications não suportadas neste navegador');
  }

  // Pedir permissão
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Permissão negada');
  }

  // Registrar SW se ainda não registrado
  const registration = await navigator.serviceWorker.ready;

  // Buscar chave VAPID do backend
  const configRes = await api.get('/push/vapid-key');
  const { publicKey } = configRes.data;

  // Criar subscription
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey)
  });

  // Enviar subscription pro backend
  await api.post('/push/subscribe', {
    userId,
    subscription: subscription.toJSON()
  });

  console.log('[Push] Inscrito com sucesso!');
  return subscription;
}

// Cancelar inscrição
export async function unsubscribeFromPush(userId) {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  
  if (subscription) {
    await subscription.unsubscribe();
    await api.post('/push/unsubscribe', { userId });
  }
}

// Verificar se já está inscrito
export async function isSubscribed() {
  if (!isPushSupported()) return false;
  
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    return !!subscription;
  } catch {
    return false;
  }
}

// Enviar notificação de teste
export async function sendTestNotification(userId) {
  const res = await api.post('/push/test', { userId });
  return res.data;
}
